import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import { theme } from '../themes/theme'

function formatUsersToAssignDropdownOptions(users) {
  const options = [{ icon: <AssignmentIndIcon />, label: 'Nobody', color: theme.colors.text.body, value: '' }]

  for (const user of users)
    options.push({ icon: <AssignmentIndIcon />, label: `${user.firstName} ${user.lastName}`, color: user.chipColor, value: user.id })

  return options
}

function getUserFilterOptionsForDashboard(users) {
  const options = [{ value: 'nobody', label: 'Nobody' }]
  for (const user of users) options.push({ value: user.id, label: `${user.firstName} ${user.lastName}` })
  return options
}

function getUserInitials(firstName, lastName) {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
}

export { formatUsersToAssignDropdownOptions, getUserFilterOptionsForDashboard, getUserInitials }
